const CATEGORY_ITEMS = {
    PAGE: 'Page',
    SUGGESTION: 'Suggestion',
    EXTERNAL: 'External',
    FOLDER: 'Folder',
    SUBCATEGORY: 'Subcategory',
    QUESTION: 'Question',
    DOCUMENT: 'Document',
};

const CATEGORY_VISIBILITY = {
    PUBLIC_VISIBLE: 0,
    TEAM_VISIBLE: 1,
    PRIVATE_VISIBLE: 2,
};

const CATEGORY_VISIBILITY_TEXT = {
    0: 'Publicly visible',
    1: 'Team visible',
    2: 'Invite only',
};

const EXTERNAL_SITES_VISIBILITY = {
    PRIVATE_VISIBLE: 0,
    PUBLIC_VISIBLE: 1,
};

const EXTERNAL_SITES_ALLOWS_SEARCH = {
    DISABLED: 0,
    ENABLED: 1,
};

const EXTERNAL_SITES_CUSTOM_DOMAIN = {
    DISABLED: 0,
    ENABLED: 1,
};

const CATEGORY_ORDER_BY_DEFAULT = {
    LAST_MODIFIED: 0,
    ALPHABETICAL_BY_NAME: 2,
    CUSTOM: 4,
};

const PAGE_VISIBILITY = {
    PUBLICLY_VISIBLE: 'Publicly visible',
    TEAM_VISIBLE: 'Team visible',
    PRIVATE: 'Private',
};

const EVENTS = {
    CATEGORIES_LOADED: 'categoriesAndFoldersLoaded',
    CREATE_QUESTION_FROM_SEARCH: 'createQuestionFromSearch',
    DISABLE_AUTO_SAVE: 'disableAutoSave',
    FOCUS_EDITOR: 'focusEditor',
    GITHUB_TOKEN_LOADED: 'githubTokenLoaded',
    GOOGLE_TOKEN_LOADED: 'googleTokenLoaded',
    INVITABLE_USERS_LOADED: 'invitableUsersLoaded',
    NEW_PAGE_LOADED: 'newPageLoaded',
    SHOW_CHOOSE_PAGE_DIALOG: 'showAnswerPageDialog',
    SHOW_SHARE_MODAL: 'showShareModal',
    UPDATED_DRAFT_VALUES: 'updatedDraftValues',
    UPDATE_SIDEBAR_NUMBER: 'updateSidebarNumber',
    USER_TODO_COUNT: 'userTodoCount',
    USERS_LOADED: 'usersLoaded',
};

const ANALYTIC_SOURCE = {
    ADD_TETTRA_LINK_MODAL: 'add_tettra_link_modal',
    ADD_DASHBOARD_PIN_MODAL: 'add_dashboard_pin_modal',
};

const ERROR = {
    IS_UPLOADING: 'Page has images/files that are still uploading. Please wait until they have uploaded and try again.',
};

const FEATURE = {
    ANALYTICS: 'analytics',
    GROUPS: 'groups',
    PRIVATE_CATEGORY: 'private',
    PUBLIC_CATEGORY: 'public',
    VERIFICATION: 'verification',
    SLACK: 'slack_integration',
    SUGGEST_EDIT: 'suggest_edit',
    EXTERNAL_SITES: 'external_sites',
    PROJECT_HYDRA: 'project_hydra',
    KAI: 'kai',
    SLACK_QA: 'slack_qa',
    KAI_DASHBOARD: 'kai_dashboard',
};

const USER_ROLE = {
    ADMIN: 1,
    EDITOR: 0,
    CONTRIBUTOR: 4,
    READ_ONLY: 2,
    GUEST: 3,
};

const USER_ROLE_TEXT = {
    ADMIN: 'admin',
    EDITOR: 'editor',
    CONTRIBUTOR: 'contributor',
    READ_ONLY: 'read-only',
    GUEST: 'guest',
};

const VERIFICATION_TYPE = {
    PAGE: 'page',
    LINK: 'link',
    DOCUMENT: 'document',
};

const BOOKMARKABLE_TYPE = {
    PAGE: 'App\\Models\\Page',
    FOLDER: 'App\\Models\\Folder',
    CATEGORY: 'App\\Models\\Category',
    EXTERNAL_RESOURCE: 'App\\Models\\ExternalResource',
    QUESTION: 'App\\Models\\Question',
    DOCUMENT: 'App\\Models\\Document',
};

const MODELS = {
    PAGE: 'App\\Models\\Page',
    QUESTION: 'App\\Models\\Question',
    SLACK_QUESTION: 'App\\Models\\SlackQuestion',
    SEARCH_QUERY: 'App\\Models\\SearchQuery',
    REVISION: 'App\\Models\\Revision',
};

const RESOURCE_MODEL = {
    ...BOOKMARKABLE_TYPE,
    SUGGESTION: 'App\\Models\\Suggestion',
    COMMENT: 'App\\Models\\Comment',
    GOOGLE_FILE: 'App\\Models\\GoogleFile',
};

const RESOURCE_MODEL_TEXT = {
    'App\\Models\\Page': 'Page',
    'App\\Models\\Question': 'Question',
    'App\\Models\\Document': 'Document',
    'App\\Models\\ExternalResource': 'Link',
};

const ICON = {
    PAGE: '/img/icons/file-icon-page.png',
    SUGGESTION: '/img/icons/file-icon-page-request.png',
    QUESTION: '/img/icons/file-icon-question.png',
    QUESTION_ANSWERED: '/img/icons/file-icon-answered-question.png',
    CLOSED_SUGGESTION: '/img/icons/file-icon-page-request-closed.png',
    UNCATEGORIZED: '/img/icons/pages-icon.svg',
    GOOGLE_DRIVE: '/img/icons/google-drive-icon.png',
    GITHUB: '/img/icons/github-icon.png',
    GITHUB_ISSUE_OPEN: '/img/icons/github-icon-open.png',
    GITHUB_ISSUE_CLOSED: '/img/icons/github-icon-closed.png',
    NOTION: '/img/icons/notion-icon.svg',
    LINK: '/img/icons/file-icon-link.png',
    PDF_DOCUMENT: '/img/icons/file-icon-document.png',
    CATEGORY: '/img/icons/category-icon.png',
    FOLDER: '/img/icons/folder-icon.png',
    COMMENT_PAGE: '/img/icons/comment-icon-page.png',
    COMMENT_SUGGESTION: '/img/icons/comment-icon-suggestion.png',
    COMMENT_QUESTION: '/img/icons/comment-icon-question.png',
    GOOGLE_DOC: '/img/icons/google-docs-icon.png',
    GOOGLE_SHEET: '/img/icons/google-sheets-icon.png',
    GOOGLE_SLIDE: '/img/icons/google-slides-icon.png',
};

const COLOR = {
    DEFAULT: 'd8d8d8',
};

const EVERYTHING = 'everything';
const SUBCATEGORIES = 'subcategories';
const PAGES = 'pages';
const QUESTIONS = 'questions';
const LINKS = 'links';
const REQUESTS = 'requests';
const DOCUMENTS = 'documents';

const RESOURCE_TYPE = {
    GOOGLE_DOCS: 'google_docs',
    GITHUB_ISSUE: 'github_issue',
    GITHUB_PR: 'github_pr',
    TETTRA_PAGE: 'tettra_page',
    TETTRA_QUESTION: 'tettra_question',
    TETTRA_PDF: 'tettra_pdf',
    TETTRA_PDF_LINK: 'tettra_pdf_link',
    TETTRA_CATEGORY: 'tettra_category',
    TETTRA_FOLDER: 'tettra_folder',
    URL: 'url',
    NOTION_PAGE: 'notion_page',
    COMMENT: 'comment',
};

const GOOGLE_MIME_TYPE = {
    DOCUMENT: 'application/vnd.google-apps.document',
    FOLDER: 'application/vnd.google-apps.folder',
};

const SEARCH_INDEX = 'unified_index';

const ACTIVE_TAB = 'active';

const CATEGORY_DEFAULT_COLOR = 'd8d8d8';

const HYDRA_RESPONSE = {
    COMPLETED: 'completed',
    FAILED_PARSING: 'failed_parsing',
    FAILED_REQUEST: 'failed_request',
    FAILED: 'failed',
    EMPTY: 'empty_response',
};

const TAG_SOURCE = {
    TEAM: 'team',
};

export {
    BOOKMARKABLE_TYPE,
    RESOURCE_MODEL,
    CATEGORY_ITEMS,
    CATEGORY_VISIBILITY,
    CATEGORY_VISIBILITY_TEXT,
    EXTERNAL_SITES_VISIBILITY,
    EXTERNAL_SITES_ALLOWS_SEARCH,
    EXTERNAL_SITES_CUSTOM_DOMAIN,
    CATEGORY_ORDER_BY_DEFAULT,
    COLOR,
    EVENTS,
    ERROR,
    FEATURE,
    ICON,
    USER_ROLE,
    USER_ROLE_TEXT,
    EVERYTHING,
    SUBCATEGORIES,
    PAGES,
    QUESTIONS,
    DOCUMENTS,
    LINKS,
    MODELS,
    REQUESTS,
    RESOURCE_TYPE,
    PAGE_VISIBILITY,
    VERIFICATION_TYPE,
    SEARCH_INDEX,
    RESOURCE_MODEL_TEXT,
    ANALYTIC_SOURCE,
    ACTIVE_TAB,
    CATEGORY_DEFAULT_COLOR,
    HYDRA_RESPONSE,
    GOOGLE_MIME_TYPE,
    TAG_SOURCE,
};
